import * as tslib_1 from "tslib";
import axios from 'axios';
var ContextTokenService = /** @class */ (function () {
    function ContextTokenService(token, baseURL) {
        this.token = token;
        this.baseURL = baseURL;
        this.contextTokens = {};
        this.apiClient = axios.create({
            baseURL: baseURL,
            headers: {
                Authorization: token,
            },
        });
    }
    ContextTokenService.prototype.getContextToken = function (groupId) {
        var contextToken = this.contextTokens[groupId];
        return Promise.resolve(contextToken || this.requestContextToken(groupId));
    };
    ContextTokenService.prototype.requestContextToken = function (groupId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var data;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.apiClient.post('/v1/integration/feed/tokens', {
                            groupIds: [groupId],
                        })];
                    case 1:
                        data = (_a.sent()).data;
                        this.contextTokens = tslib_1.__assign({}, this.contextTokens, data.tokens);
                        return [2 /*return*/, this.contextTokens[groupId]];
                }
            });
        });
    };
    return ContextTokenService;
}());
export { ContextTokenService };
//# sourceMappingURL=context-token.service.js.map